import { Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { DamageType } from "../damageType";
import { Center } from "../center";
import { IEvaluatorDamageType, IEvaluatorDamageTypeProps, IEvaluatorDamageTypeStates } from "./interfaces";
import { ICenterProps } from "../center/interfaces";

export class EvaluatorDamageType extends EntityManager<IEvaluatorDamageType, IEvaluatorDamageTypeProps, IEvaluatorDamageTypeStates> {
    static initMetadata = (): IMetadata => {
        return {
            title: "نوع خسارت مجاز ارزیابی",
            name: "EvaluatorDamageType",
            Properties: [
                {
                    title: "ارزیاب",
                    dataIndex: "EvaluatorId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا ارزیاب را وارد نمایید' }],
                    lookup: {
                        lookupComponent: Center,
                        lookupProperty: "Evaluator",
                        lookupDisplayFields: ["FullName"]
                    }
                },
                {
                    title: "نوع خسارت",
                    dataIndex: "DamageTypeId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا نوع خسارت را وارد نمایید' }],
                    lookup: {
                        lookupComponent: DamageType,
                        lookupProperty: "DamageType",
                        lookupDisplayFields: ["Name"]
                    }
                }
            ]
        };
    }
    onInitializing() {

        this.preparelookupProps = (propName, lookupProps: any) => {
            if (propName === "EvaluatorId")
                (lookupProps as ICenterProps).isEvaluator = true;

            return lookupProps;
        };

        this.originalFilter = () => {
            if (this.props.params && this.props.params()?.evaluator) {
                return ComparisonFilter.Equal<IEvaluatorDamageType>(m => m.EvaluatorId, this.props.params && this.props.params()?.evaluator?.Id);
            }
        };
        this.extraHeaderNodes = () => {
            return (
                <Descriptions className="header-page">
                    <Descriptions.Item label="مرکز ارزیابی">{this.props.params && this.props.params().evaluator?.FullName}</Descriptions.Item>
                </Descriptions>
            );
        };
        this.onEntityAdded = (entity) => {
            let evaluator = this.props.params && this.props.params().evaluator
            if (evaluator) {
                entity.EvaluatorId = evaluator.Id;
                entity.Evaluator = evaluator;
                entity.ModifiedProperties.push("EvaluatorId");
            }
            return true;
        };
    }
}
